/**
 * verooglIcons — maps a string icon_key stored in Mongo to the actual
 * lucide-react component.  Edit-modal uses the keys for its picker.
 * Keep the list tight so the picker stays scannable.
 */
import {
  Radio, FileText, ShieldCheck, FileSignature, Scale,
  BarChart3, Siren, AlertTriangle, Layers,
  Landmark, Wallet, PackageSearch, Globe,
  Code2, Zap, LifeBuoy, HeartHandshake,
  Search, Gauge, Workflow, Receipt, CreditCard, Users, Lock, Mail,
  MessageSquare, Phone, DollarSign, LineChart, Target, Rocket,
} from "lucide-react";

export const VEROOGLE_ICONS = {
  "radio": Radio,
  "file-text": FileText,
  "shield-check": ShieldCheck,
  "file-signature": FileSignature,
  "scale": Scale,
  "bar-chart-3": BarChart3,
  "siren": Siren,
  "alert-triangle": AlertTriangle,
  "layers": Layers,
  "landmark": Landmark,
  "wallet": Wallet,
  "package-search": PackageSearch,
  "globe": Globe,
  "code-2": Code2,
  "zap": Zap,
  "life-buoy": LifeBuoy,
  "heart-handshake": HeartHandshake,
  "search": Search,
  "gauge": Gauge,
  "workflow": Workflow,
  "receipt": Receipt,
  "credit-card": CreditCard,
  "users": Users,
  "lock": Lock,
  "mail": Mail,
  "message-square": MessageSquare,
  "phone": Phone,
  "dollar-sign": DollarSign,
  "line-chart": LineChart,
  "target": Target,
  "rocket": Rocket,
};

export const resolveIcon = (key) => VEROOGLE_ICONS[key] || Radio;

export const ICON_KEYS = Object.keys(VEROOGLE_ICONS);
